export default __webpack_public_path__ + "static/media/12.867fbf76.mp3";